import { HelmetDexteel } from "@dexteel/mesf-core";
import { RollTurnHistoryDetail } from "./components/RollTurnHistoryDetail";

export const RollTurnHistoryDetailPage = () => (
	<>
		<HelmetDexteel title="Roll Turn History Detail" />
		<RollTurnHistoryDetail />
	</>
);
